import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, units } from '@calm-web/design-system';

import AuthForm from '@/components/authForm/AuthForm';
import { ContentWrapper } from '@/components/dtcPartnerships/shared/styles';
import LockOutlineSvg from 'icons/lock-outline.svg';
import MailSvg from 'icons/mail.svg';
import ProfileOutlineSvg from 'icons/profile-outline.svg';

export const BackButton = styled.div`
	margin-top: 24px;
	display: flex;
	cursor: pointer;
	align-items: center;

	${minWidth('desktop')} {
		margin: 0;
	}
`;

export const BackButtonText = styled.div`
	text-transform: capitalize;
	${fontWeight(FontWeights.Medium)};
	margin-left: 12px;
`;

export const CtaText = styled.h1`
	margin-top: ${units(4)};
	${fontWeight(FontWeights.Demi)}
	font-size: ${units(2.25)};
	line-height: 150%;
	color: ${palette('gray7')};
	text-align: left;

	${minWidth('mobileLarge')} {
		${fontSize(FontSizes.lg)}
	}

	${minWidth('tablet')} {
		margin-top: ${units(3.56)};
		${fontWeight(FontWeights.Medium)}
	}
`;

export const DTCLoginForm = styled(AuthForm)`
	margin-top: ${units(4)};

	.loginTerms {
		display: none;
	}
	.loginToggleWrapper {
		display: none;
	}
	.loginOrDivider {
		margin: ${units(2)} 0;

		${minWidth('tablet')} {
			margin: ${units(1.78)} 0;
		}
	}
	.forgotPasswordWrapper {
		${fontWeight(FontWeights.Medium)};
	}

	${minWidth('tablet')} {
		margin-top: ${units(3.56)};
	}
`;

export const FaqText = styled.div`
	font-size: ${units(1.5)};
	margin-top: ${units(4)};
	text-align: left;
	${fontWeight(FontWeights.Medium)}
	line-height: 150%;
	letter-spacing: ${units(0.04)};
	color: ${palette('gray8')};

	${minWidth('tablet')} {
		${fontWeight(FontWeights.Regular)}
		margin-top: ${units(3.56)};
		font-size: ${units(1.44)};
	}
`;

export const FaqLink = styled.a`
	font-weight: 600;
	text-decoration: underline;
`;

export const TermsText = styled.div`
	margin-top: ${units(2.5)};
	text-align: left;
	${fontWeight(FontWeights.Medium)}
	font-size: ${units(1.5)};
	line-height: 150%;
	letter-spacing: ${units(0.04)};
	color: ${palette('gray8')};

	a {
		font-weight: 600;
		text-decoration: underline;
		color: inherit;
	}

	${minWidth('tablet')} {
		${fontWeight(FontWeights.Regular)}
		margin-top: ${units(2.22)};
		font-size: ${units(1.44)};
	}
`;

export const BackButtonContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const AccountContentWrapper = styled(ContentWrapper)`
	${minWidth('tablet')} {
		padding: ${units(4.44)} ${units(4.67)};
	}
`;

export const formInputIconSvgCss = css`
	display: block !important;

	${minWidth('mobileLarge')} {
		height: 30px !important;
		width: 30px !important;
	}

	& path {
		fill: ${palette('gray2')} !important;
	}
`;

export const ProfileIcon = styled(ProfileOutlineSvg)`
	${formInputIconSvgCss}
`;

export const MailIcon = styled(MailSvg)`
	${formInputIconSvgCss}
`;

export const LockIcon = styled(LockOutlineSvg)`
	${formInputIconSvgCss}
`;
